// Dev-only logger: console.log + on-screen overlay so messages are visible
// on the device without needing terminal / remote devtools.
// Activate by appending ?debug=1 to the URL, or setting localStorage.devLog=1.
// Persists across reloads via localStorage when ?debug=1 is used.

let panelEl = null
let listEl = null

function isEnabled() {
    // Compiled in at build time. .env.dev has VUE_APP_IS_DEBUG=1 → overlay
    // shows on dev. Flip to 0 (or remove) in .env.prod to disable.
    if (process.env.VUE_APP_IS_DEBUG === '1') return true
    // Manual override for browser testing.
    try {
        const qs = window.location.search || ''
        if (/[?&]debug=1\b/.test(qs)) {
            localStorage.setItem('devLog', '1')
            return true
        }
        if (/[?&]debug=0\b/.test(qs)) {
            localStorage.removeItem('devLog')
            return false
        }
        return localStorage.getItem('devLog') === '1'
    } catch (e) {
        return false
    }
}

function ensurePanel() {
    if (panelEl) return
    panelEl = document.createElement('div')
    panelEl.id = '__devlog__'
    panelEl.style.cssText = [
        'position:fixed',
        'top:0',
        'left:0',
        'right:0',
        'max-height:35vh',
        'overflow:auto',
        'background:rgba(0,0,0,0.85)',
        'color:#0f0',
        'font:11px/1.3 monospace',
        'padding:4px 6px',
        'z-index:99999',
        'pointer-events:auto',
        'white-space:pre-wrap',
        'word-break:break-all',
    ].join(';')

    const header = document.createElement('div')
    header.style.cssText = 'display:flex;gap:8px;color:#ff0;margin-bottom:2px;'
    const title = document.createElement('span')
    title.textContent = '[devLog]'
    const clearBtn = document.createElement('button')
    clearBtn.textContent = 'clear'
    clearBtn.style.cssText = 'background:#333;color:#fff;border:1px solid #666;font:10px monospace;'
    clearBtn.onclick = (e) => { e.stopPropagation(); if (listEl) listEl.innerHTML = '' }
    const hideBtn = document.createElement('button')
    hideBtn.textContent = 'hide'
    hideBtn.style.cssText = clearBtn.style.cssText
    hideBtn.onclick = (e) => {
        e.stopPropagation()
        localStorage.removeItem('devLog')
        if (panelEl && panelEl.parentNode) panelEl.parentNode.removeChild(panelEl)
        panelEl = null
        listEl = null
    }
    header.appendChild(title)
    header.appendChild(clearBtn)
    header.appendChild(hideBtn)
    panelEl.appendChild(header)

    listEl = document.createElement('div')
    panelEl.appendChild(listEl)

    const mount = () => document.body && document.body.appendChild(panelEl)
    if (document.body) mount()
    else document.addEventListener('DOMContentLoaded', mount, { once: true })
}

export function devLog(...args) {
    // No-op unless enabled (VUE_APP_IS_DEBUG=1, ?debug=1, or localStorage.devLog=1).
    // Return BEFORE console.log so a disabled build emits nothing to the console
    // either. NOTE: .env.prod currently sets VUE_APP_IS_DEBUG=1, so this is still
    // active in prod — set it to 0 (or decouple devLog onto its own flag) to silence.
    if (!isEnabled()) return
    // eslint-disable-next-line no-console
    console.log(...args)
    try {
        ensurePanel()
        if (!listEl) return
        const line = document.createElement('div')
        const ts = new Date().toISOString().slice(11, 23)
        const body = args
            .map((a) => {
                if (typeof a === 'string') return a
                try { return JSON.stringify(a) } catch (e) { return String(a) }
            })
            .join(' ')
        line.textContent = `${ts}  ${body}`
        listEl.appendChild(line)
        // keep last ~200 lines
        while (listEl.childNodes.length > 200) listEl.removeChild(listEl.firstChild)
        listEl.scrollTop = listEl.scrollHeight
    } catch (e) {
        // swallow — logging must never break the app
    }
}
